import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_unit_spaces';
// Example set of params

const unitSpacesQuery = `
    query UnitSpaces($listingId: String!, $state: AmenityState) {
        unitSpaces(id: $listingId, state: $state) {
            bedrooms {
                contentItems {
                    amenity {
                        displayName
                    }
                    amenityName
                    stringAttributeValues {
                        attributeName
                        attributeValue
                    }
                }
                name
                note
            }
            spacesSummary {
                bedroomDetails
                bathroomDetails
                area {
                    areaValue
                    areaUnits
                }
                areaDisplay
            }
            bathrooms {
                contentItems {
                    amenity {
                      displayName
                    }
                    amenityName
                    stringAttributeValues {
                        attributeName
                        attributeValue
                    }
                }
                name
              	note
                type
            }
            diningRooms {
                name
                note
                type
                capacity
            }
        }
    }
`;

async function unitSpacesGraphQl({listingId, locale}) {
    const params = {listingId, state: 'PREBOOKING'};

    return await graphqlQuery(OPERATION_NAME, unitSpacesQuery, params, locale);
}

export default unitSpacesGraphQl;
export {unitSpacesGraphQl, OPERATION_NAME, unitSpacesQuery};
